import { useRef } from "react";
export function useReduce(reduce, ...args) {
    const ref = useRef();
    return (ref.current = reduce(ref.current, ...args));
}
